import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import axiosInstance from '../plugins/axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

// Verify session via the backend API when localStorage doesn't have isAuthenticated.
// The backend sets an httpOnly session cookie on .myfinfi.com at login time.
// That cookie is sent automatically by the browser to any *.myfinfi.com subdomain,
// so we can verify it without any manual cookie/localStorage state transfer between apps.
async function verifySession() {
  try {
    const res = await axiosInstance.get('/cualitywork/auth-user')
    if (res.data) {
      localStorage.setItem('isAuthenticated', 'true')
      // Rebuild user in localStorage from fresh API response
      const userData = { ...res.data }
      localStorage.setItem('user', JSON.stringify(userData))
      // Rebuild finfi._vuex so Vuex picks up permissions on this navigation
      const vuexState = {
        wfmPermissions: userData.wfmPermissions || [],
        wfmStatements: userData.wfmStatements || [],
        useCase: [],
        subCases: [],
        selectValue: null,
        inputValue: null,
      }
      localStorage.setItem('finfi._vuex', JSON.stringify(vuexState))
      return true
    }
  } catch (_) {
    // 401 or network error → treat as not authenticated
  }
  return false
}

router.beforeEach(async (to, from, next) => {
  let isAuthenticated = Vue.prototype.$storage?.getUniversal('isAuthenticated')
  const needsInitialSetup = localStorage.getItem('needsInitialSetup')
  const hasCompletedSetup = Vue.prototype.$storage?.getUniversal('hasCompletedSetup')

  // If the route needs auth and we don't have it in localStorage,
  // try verifying the backend session before giving up and redirecting to login.
  if (to.meta.private && !isAuthenticated) {
    const sessionValid = await verifySession()
    if (sessionValid) {
      isAuthenticated = true
    } else {
      next({ name: 'Login' })
      return
    }
  }

  if (
    isAuthenticated &&
    needsInitialSetup === 'true' &&
    !hasCompletedSetup &&
    to.name !== 'SetupPage'
  ) {
    next({ name: 'SetupPage' })
  } else if (to.meta.public && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else if (
    isAuthenticated &&
    to.name === 'SetupPage' &&
    (!needsInitialSetup || needsInitialSetup !== 'true' || hasCompletedSetup)
  ) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

router.afterEach((to) => {
  // If running inside an iframe (embedded in the mobile app),
  // notify the parent so it can persist our current path.
  // This lets the mobile app restore us to this exact page on refresh.
  try {
    if (window.self !== window.top) {
      window.parent.postMessage(
        { type: 'ADMIN_ROUTE_CHANGE', path: to.fullPath },
        '*'
      )
    }
  } catch (_) {
    // cross-origin access blocked — safe to ignore
  }
})

export default router
